export default __webpack_public_path__ + "506fbe565e8219160b5a9d4d6abdf930.svg";